import {
  apiGet,
  apiPost,
  apiDelete,
  apiPut,
  apiDownloadPost,
} from '../../api/index';

import { urlExams } from '../../api/urls';

export function fetchExams(params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 15 };
  return apiPost(`${urlExams}/all`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function confirmExam(id, exam, callback) {
  return apiPost(`${urlExams}/${id}/confirm`, exam)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function fetchExam(id, callback) {
  return apiGet(`${urlExams}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function fetchExamPrintPreview(id, type, callback) {
  const url = type === null
    ? `${urlExams}/report/${id}`
    : `${urlExams}/report/${id}/${type}`;

  return apiGet(url)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function saveExam(exam, callback) {
  return apiPost(`${urlExams}`, exam)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function deleteExam(id, callback) {
  return apiDelete(`${urlExams}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function stampExam(id, exam, callback) {
  return apiPut(urlExams, id, exam)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function openExam(id, exam, callback) {
  return apiPut(`${urlExams}/open`, id, exam)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function fetchFormDatas(anhoLectivoId, params) {
  return apiGet(`${urlExams}/form_data/${anhoLectivoId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}


export function getExamenesPorCarrera(params) {
  return apiGet(`${urlExams}/por_carrera/${params.id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function downloadAcademicStatusStudent({ id, materiaName }, params) {
  return apiDownloadPost(`${urlExams}/download-score-report/${id}`)
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${materiaName}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      if (params && params.onSuccess) params.onSuccess(blob);
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}
